import Component from '../Component';

class LinksBlock extends Component {
    constructor() {
        super();
    }

    componentDidMount() {
        this.children.forEach((child) => {
            child.setRefs(this.refs);
            child.componentDidMount();
        });
    }

    render() {
        return `
    ${this.children.map((child => {
        return child.render();
    })).join('')}
        `;
    }
}

export default LinksBlock;